var _circle, _circle2, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBtnDeleted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#5754E5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#5754E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.625 26.7917L45.7471 40.994C45.5227 44.6225 45.4106 46.4368 44.5011 47.7413C44.0513 48.3861 43.4725 48.9304 42.801 49.3394C41.443 50.1667 39.6252 50.1667 35.9897 50.1667C32.3494 50.1667 30.5293 50.1667 29.1703 49.3379C28.4985 48.9282 27.9193 48.3829 27.4698 47.7369C26.5606 46.4304 26.4509 44.6136 26.2315 40.9799L25.375 26.7917",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 26.7916H48.75M41.7456 26.7916L40.7786 24.7965C40.1361 23.4713 39.8148 22.8087 39.2607 22.3954C39.1379 22.3037 39.0077 22.2222 38.8716 22.1516C38.258 21.8333 37.5216 21.8333 36.0489 21.8333C34.5391 21.8333 33.7843 21.8333 33.1605 22.1649C33.0223 22.2384 32.8904 22.3233 32.7662 22.4186C32.2057 22.8486 31.8926 23.5354 31.2664 24.9092L30.4083 26.7916",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.459 42.375V33.875",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.541 42.375V33.875",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnDeleted);
export default __webpack_public_path__ + "static/media/btnDeleted.f650f72c48c790060059913047ced694.svg";
export { ForwardRef as ReactComponent };